import type { MultiLang } from '../../config';
import Functions from '../../functions';

interface Props {
    lang: MultiLang;
}

export const ARCHIVED_NOTICE =
    '[en]This site has been archived since FY2019 and is no longer updated.[/en][ja]このサイトは、2019年度よりアーカイブサイトとして運用されています。[/ja]';

const NoticeSiteHasBeenArchived = (props: Props) => {
    const { lang } = props;
    return <p style={{ color: 'red' }}>{Functions.mlang(ARCHIVED_NOTICE, lang)}</p>;
};

export default NoticeSiteHasBeenArchived;
